module.exports = __webpack_public_path__ + "static/media/IMG-3.73b92c93.jpg";